import useTranslations from '@hooks/useTranslations';
import { FC } from 'react';
import { SC } from '../../styles/theme';

export const LoginSaveCarTemplate: FC<SC> = ({ className }) => {
    const { t } = useTranslations();
    return <p className={className}>{t('login.carWillBeSaved')}</p>;
};
